var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect } from "react";
import Button from "../../atoms/button/button";
import ErrorMessage from "../../atoms/errorMessage/errorMessage";
import InputField from "../../molecules/inputField/inputField";
import { useDispatch, useSelector } from "react-redux";
import showPopupModal from "../../../redux/actions/popupModal";
import { inviteUserToOrganisation, inviteUserToSuperorg, clearInviteMessage, fetchPendingInvites } from "../../../redux/actions/invite_user";
import { getProfileData } from "../../../redux/actions/profile";
import "./InviteTeamMember.css";
import { ButtonType } from "../../atoms/button/buttonType";
var InviteTeamMember = function () {
    var dispatch = useDispatch();
    var _a = useState(""), email = _a[0], setEmail = _a[1];
    var _b = useState(""), errorMsg = _b[0], setErrorMsg = _b[1];
    var _c = useState(false), showConfirmation = _c[0], setShowConfirmation = _c[1];
    var logged_in_user_type = useSelector(function (state) { return state.rootReducer.dashboardReducer.logged_in_user_type; });
    var username = useSelector(function (state) { return state.rootReducer.userReducer.username; });
    var orgId = useSelector(function (state) { return state.rootReducer.profileReducer.id; });
    var caseload = useSelector(function (state) { return state.rootReducer.ManageUserReducer.caseload; });
    var inviteState = useSelector(function (state) { return state.rootReducer.InviteUserReducer; });
    useEffect(function () {
        if (inviteState.status === "success") {
            setShowConfirmation(true);
            if (orgId && logged_in_user_type) {
                dispatch(fetchPendingInvites(orgId, logged_in_user_type));
            }
            setTimeout(function () {
                dispatch(clearInviteMessage());
                dispatch(showPopupModal(false));
                setEmail("");
            }, 2000);
        }
    }, [inviteState.status, dispatch, orgId, logged_in_user_type]);
    // Load profile data if orgId is not available
    useEffect(function () {
        if (!orgId && username) {
            dispatch(getProfileData());
        }
    }, [orgId, username, dispatch]);
    var validateEmail = function (email) {
        var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    var handleSubmit = function () {
        setErrorMsg("");
        if (!email.trim()) {
            setErrorMsg("Please enter an email address");
            return;
        }
        if (!validateEmail(email)) {
            setErrorMsg("Please enter a valid email address");
            return;
        }
        if (!orgId) {
            setErrorMsg("Loading organisation information... please try again");
            return;
        }
        // Get the ID based on logged in user type
        // The logged-in user's ID IS the organisation/superorg ID
        // All invited users will be members
        if (logged_in_user_type === "organisation") {
            dispatch(inviteUserToOrganisation(email, orgId, "member"));
        }
        else if (logged_in_user_type === "superorg") {
            dispatch(inviteUserToSuperorg(email, orgId, "member"));
        }
    };
    if (showConfirmation) {
        return (_jsxs(_Fragment, { children: [_jsx("h1", __assign({ className: "mb-4" }, { children: "Success!" })), _jsxs("p", { children: ["Invitation sent to ", _jsx("strong", { children: email })] }), _jsx("p", __assign({ className: "mt-2 text-sm text-gray-600" }, { children: "They will receive an email with a registration link to join your team." }))] }));
    }
    return (_jsx("div", __assign({ className: "invite-team-member-container" }, { children: _jsxs("div", __assign({ className: "invite-form-content" }, { children: [_jsx("h1", __assign({ className: "invite-form-title" }, { children: "Invite Member" })), _jsxs("p", __assign({ className: "invite-form-description" }, { children: ["Invite a new user to join your ", logged_in_user_type === "organisation" ? "organisation" : "superorg", " as a team member"] })), inviteState.errorMessage && (_jsx("div", __assign({ className: "invite-error-wrapper" }, { children: _jsx(ErrorMessage, { message: inviteState.errorMessage }) }))), _jsxs("div", __assign({ className: "invite-form-field" }, { children: [_jsx("label", __assign({ className: "login" }, { children: "Email Address *" })), _jsx(InputField, { value: email, onChange: function (e) { return setEmail(e.target.value); }, placeholder: "email@example.com", className: "mt-2" })] })), _jsxs("div", __assign({ className: "invite-button-group" }, { children: [_jsx(Button, { border: "none", onClick: handleSubmit, disabled: inviteState.status === "loading", text: inviteState.status === "loading" ? "Sending..." : "Send Invitation", className: "invite-button-primary" }), _jsx(Button, { border: "none", onClick: function () {
                                dispatch(showPopupModal(false));
                                dispatch(clearInviteMessage());
                            }, buttonType: ButtonType.OutlinedSecondary, text: "Cancel", className: "invite-button-secondary" })] })), errorMsg && (_jsx("div", __assign({ className: "invite-error-wrapper" }, { children: _jsx(ErrorMessage, { message: errorMsg }) })))] })) })));
};
export default InviteTeamMember;
